import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import PostmanImporterPreview from './PostmanImporterPreview';
import PostmanImporterControls from './PostmanImporterControls';

const PostmanImporter = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.POSTMAN_IMPORTER]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.POSTMAN_IMPORTER, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.POSTMAN_IMPORTER, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Postman Collection Importer</h2>
      <PostmanImporterControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const PostmanImporterPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.POSTMAN_IMPORTER]);
  return <PostmanImporterPreview config={config} />;
};

export default PostmanImporter;

